import { BASE_BE_URL } from "../AppEnv";
import { BASE_AUTH_SUBURL, BASE_DOC_SUBURL } from "../env";
import {
  SignInDoctor,
  SignedInDoctor,
  UnloggedDoctor,
  UnloggedAdmin,
} from "./interfaces";

export async function signIn(signInDto: SignInDoctor): Promise<string> {
  try {
    //console.log("Log in with data ", signInDto);
    const response = await fetch(
      BASE_BE_URL + BASE_AUTH_SUBURL + "doc-signin",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signInDto),
      }
    );
    if (!response.ok) return await response.text();
    else return (await response.json()).access_token;
  } catch (error) {
    //console.log(error);
    return "";
  }
}

export async function adminsignIn(signInDto: SignInDoctor): Promise<string> {
  try {
    //console.log("Log in with data ", signInDto);
    const response = await (
      await fetch(BASE_BE_URL + BASE_AUTH_SUBURL + "admin-signin", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signInDto),
      })
    ).json();

    return response.access_token;
  } catch (error) {
    return "";
  }
}

export async function getMe(token: string): Promise<SignedInDoctor> {
  try {
    let meResp = await fetch(BASE_BE_URL + BASE_AUTH_SUBURL + "me", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (!meResp.ok) return UnloggedDoctor;
    let myId: number = (await meResp.json()).id;

    if (myId != NaN) {
      const signedIn: SignedInDoctor = await (
        await fetch(BASE_BE_URL + BASE_DOC_SUBURL + myId, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
      ).json();
      signedIn.token = token;

      return signedIn;
    } else return UnloggedDoctor;
  } catch (error) {
    //console.log("Error: " + error);
    return UnloggedDoctor;
  }
}

export async function getAdminMe(token: string): Promise<SignedInDoctor> {
  try {
    let myAdminInfoResp = await fetch(
      BASE_BE_URL + BASE_AUTH_SUBURL + "admin",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!myAdminInfoResp.ok) return UnloggedAdmin;
    let myAdminInfo = await myAdminInfoResp.json();
    myAdminInfo.token = token;
    return myAdminInfo;
  } catch (error) {
    //console.log("Error: " + error);
    return UnloggedAdmin;
  }
}

export async function isLogged(
  signedInDoctor: SignedInDoctor
): Promise<boolean> {
  if (signedInDoctor.id > 0) {
    try {
      let me: SignedInDoctor = await getMe(signedInDoctor.token);
      return me.id > 0 && me.id === signedInDoctor.id;
    } catch (error) {
      console.log("Error: " + error);
      return false;
    }
  } else return false;
}
